<div class="modal-header">
    <h4 class="modal-title pull-left">NOI / Rent Schedule</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="onClose($event)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <!--<div class="form-group" *ngIf="AutoPopulated">
        <div class="infobg">
            <span class="icon-info icon" style="color:red"></span> Sales details have been auto-populated based on the latest offer entry against this property.
        </div>
    </div>-->
    <div class="form-group">
        <label class="form-label">
            Years
            <span class="star">*</span>
        </label>
        <div class="textbox-with-btn">
            <input [(ngModel)]="Years" [min]="0" required="required"
                   dropSpecialCharacters="false" class="form-control " value="{{Years}}" (ngModelChange)="yearvalidate($event)">        
            <p class="redtext" *ngIf="IsValidYears">
                Please enter a valid years
            </p>    
        </div>
    </div>
    <div class="form-group">
        <label class="form-label">Start Date
            <span class="star">*</span>
        </label>
        <div class="textbox-date">
            <input (ngModelChange)="dateOverlapValidation($event,1)" type="text" maxlength="10" name="txtSaleDate" [(ngModel)]="LeaseStartDate" required="required" class="form-control" bsDatepicker>
            <i class="icofont icofont-ui-calendar icon"></i>
            <p class="redtext" *ngIf="IsStartDateValid">
                Please enter a valid date
            </p>
        </div>
    </div>
    <div class="form-group">
        <label class="form-label">End Date
            <span class="star">*</span>
        </label>
        <div class="textbox-date">
            <input (ngModelChange)="dateOverlapValidation($event,2)" type="text" maxlength="10" name="txtSaleDate" [(ngModel)]="LeaseEndDate" required="required" class="form-control" bsDatepicker>
            <i class="icofont icofont-ui-calendar icon"></i>
            <p class="redtext" *ngIf="IsEndDateValid">
                Please enter a valid date
            </p>
        </div>
    </div>
    <div class="form-group">
        <label class="form-label">
            Rent/NOI
            <span class="star">*</span>
        </label>
        <div class="textbox-with-btn-left">
            <input (ngModelChange)="calcIncreasePercent($event)" [(ngModel)]="NetOperatingIncome" [min]="0" required="required" currencyMask  [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" 
                   dropSpecialCharacters="false" class="form-control " maxlength="18" value="{{NetOperatingIncome |number: '0.0-0'}}">
            <span class="leftlabel">$</span>
            <p class="redtext" *ngIf="IsValidNetOperatingIncome">
                Please enter a valid rent
            </p>
        </div>
    </div>
    <div class="form-group">
        <label class="form-label">
            Increase Percentage
            <label class="custom-checkbox " for="checkbox12" style="float:right; height:10px">
                <input  id="chkCalcPSF" (ngModelChange)="calcNOIBasedOnPercent($event)" type="checkbox" [(ngModel)]="IsIncreaseAutoCalc"> Auto Calc
                <i></i>
            </label>
        </label>
        <div class="textbox-with-btn textbox-with-2character">
            <input (keyup)="IsIncreaseAutoCalc = false" class="form-control" [dropSpecialCharacters]="false" mask="999.99" [(ngModel)]="Increase" maxlength="6" (ngModelChange)="validatePercentage($event)"
                   value="{{Increase |  number: '0.0-2'}}">
            <span class="rightlabel">%</span>
        </div>
        <div *ngIf="!isValidIncrease">
            <p class="redtext" *ngIf="Increase>100">
                Increase cannot be greater than 100
            </p>
            <p class="redtext" *ngIf="Increase<0">
                Increase cannot be less than 0
            </p>
        </div>
    </div>   
    <div class="text-right">
        <button type="button" (click)="onClose($event)" class="btn btn-default btn-lg">Cancel</button>
        <button type="button" (click)="saveSalesDetails()" class="btn btn-success btn-lg">Save</button>
    </div>
</div>

